import { IActionBase, IBalanceState } from "../models/root.interface";
import { ADD_IS_POSTPAID, ADD_BASE_CURRENCY_VALUE, ADD_MAX_POSTPAID_LIMIT, ADD_BASE_CURRENCY_SYMBOL, ADD_POSTPAID_USAGE, ADD_FULL_BALANCE, IS_LOADING } from "../actions/balance.action";


const initialState: IBalanceState = {
   isPostpaid:0, baseCurrencyVal:0, maxPostpaidLimit:0,baseCurrencySymbol:"",postPaidUsage:0,fullBalanceObject:{}, isPrepaid: null,loading:false
};
function balanceReducer(state: IBalanceState = initialState, action: IActionBase): IBalanceState {
    switch (action.type) {
        case ADD_IS_POSTPAID: {
            return {...state, isPostpaid:action.isPostpaid, isPrepaid:action.isPostpaid};
        }
        case ADD_BASE_CURRENCY_VALUE: {
            return {...state, baseCurrencyVal:action.baseCurrencyVal};
        }
        case ADD_MAX_POSTPAID_LIMIT: {
            return {...state, maxPostpaidLimit:action.maxPostpaidLimit};
        }
        case ADD_BASE_CURRENCY_SYMBOL: {
            return {...state, baseCurrencySymbol:action.baseCurrencySymbol};
        }
        case ADD_POSTPAID_USAGE: {
            return {...state, postPaidUsage:action.postPaidUsage};
        }
        case ADD_FULL_BALANCE: {
            return {...state, fullBalanceObject:action.fullBalanceObject};
        }
        case IS_LOADING: {
            return {...state, loading:action.loading};
        }
        default:
            return state;
    }
}


export default balanceReducer;